// Directory of form classes
export const BASIC_FORM = "BASIC FORM"
export const RECOGNISED_FORM = "RECOGNISED FORM"
export const SINGLE_ARRAY_FORM = "SINGLE ARRAY FORM"
export const MULTI_OPTION_ARRAY_FORM = "MULTI OPTION ARRAY FORM"
